import { InfoHint } from '@eo/shared';

import { TERM_HELP } from './constants';
import { ForecastBreakdown } from './ForecastBreakdown';
import type { ClientForecastProps } from './types';

export function ClientForecast({ forecast }: ClientForecastProps) {
  return (
    <section
      data-testid="client-forecast"
      className="flex max-w-md flex-col gap-2 border-l-2 border-border-faint pl-3"
    >
      <h3 className="flex items-center gap-1 text-xs text-text-tertiary">
        Forecast
        <InfoHint term="Forecast">{TERM_HELP.forecast}</InfoHint>
      </h3>
      <ForecastBreakdown forecast={forecast} />
    </section>
  );
}
